import { computed } from 'vue'

export default {
    name: 'ProductCard',
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    setup(props) {

        var desktopImageUrl = computed(() => props.data.imageUrl + '?io=transform:fill,width:600,height:480')
        var mobileImageUrl = computed(() => props.data.imageUrl + '?io=transform:fill,width:400,height:320')

        return {
            desktopImageUrl,
            mobileImageUrl
        }
    }
}
